<template>
  <div>
    <h2></h2>
    <h2 class="title">Catalog</h2>
    
    <iframe src="https://docs.google.com/document/d/e/2PACX-1vS7jFugbCHWqbkhQ2CpC-YHz6cNuHBylH_cMwO5KBgZheJYZgtz2zNVrvXBOnKFkRSlMujzmkQFMVpg/pub?embedded=true"
            width="100%" height="1500" frameborder="0" allowtransparency="true" scrolling="auto" style="{FILTER: Chroma(Color = #FFFFFF)}"></iframe>
    <!--
    <div class="row">
      <Item
        v-for="item in forSale"
        :key="item.invId"
        :invId="item.invId"
        :name="item.name"
        :image="item.image"
        :quantity="item.quantity"
        :price="item.price" />
    </div>
    -->
  </div>
</template>

<script>
  import Item from './Item.vue';
  import Cart from './Cart.vue';

  export default {
    components: {Item, Cart},
    computed: {
      forSale() {
        return this.$store.getters.forSale;
      },
      inCart() {
        return this.$store.getters.inCart;
      }
    },
    name: 'Catalog',
  };
</script>



// WEBPACK FOOTER //
// Catalog.vue?6892ac40